import template from 'string-placeholder';
import { INVALID_CONTENT_REQUEST } from '../contactUs/constants/ActionTypes';

const defaultConfig = { before: '{', after: '}' };

const contentHelper = (content, data, option = defaultConfig) => {
  if (content) {
    if (data) {
      return template(content, data, option);
    }
    return template(content, undefined, { ...defaultConfig, clean: true });
  }

  return INVALID_CONTENT_REQUEST;
};

export default contentHelper;
